import React from 'react';
import { Form, FormModal, Select } from 'components';
import { usePriceReferenceSupplierEditModal } from 'feature/brandTabs/pricingAndSuppliers/mainSupplier/priceRefrenceSupplier/edit/usePriceReferenceSupplierEditModal';

export interface IPriceReferenceSupplierModal {
  modalState: boolean;
  onModalStateChange: () => void;
  dataToEdit: Record<string, string>;
}

export const PriceReferenceSupplierModal = (props: IPriceReferenceSupplierModal) => {
  const { modalState, onModalStateChange, dataToEdit } = props;
  const { onFinish, contextHolder, isLoading, form, onCancel, brandSupplierSelectList } =
    usePriceReferenceSupplierEditModal({
      onModalStateChange,
      modalState,
      dataToEdit,
    });
  return (
    <>
      {contextHolder}
      <FormModal
        form={form}
        title={'Update Price Reference Supplier'}
        width={400}
        okText={'Save'}
        open={modalState}
        isLoading={isLoading}
        onCancel={onCancel}
        onSubmit={onFinish}
      >
        <Form.Item label={'Price Reference Supplier'} name={'supplierId'}>
          <Select options={brandSupplierSelectList} size={'large'} />
        </Form.Item>
      </FormModal>
    </>
  );
};
